import { useCallback, useEffect, useState } from "react";
import { useApi } from "../../api";
import { PageHeader } from "../GenericPage";
import { n2 } from "../../lib/format";
import { Modal, MoneyInput, Notice, parseMoney } from "../../lib/ui";

/*
 * Process payables (other payments) – port of other_payments_form.php (API: /api/other-payments)
 * Recorded by bank transfer as 'unverified'. Verify posts Dr the type's account / Cr Bank 1010 (verify_other_payment);
 * delete removes it (refused once it's in the ledger).
 */

export default function OtherPayments({ user }) {
  const api = useApi();
  const [d, setD] = useState(null);
  const [clients, setClients] = useState([]);
  const [f, setF] = useState({ client_id: "", payment_type: "", amount: "" });
  const [notice, setNotice] = useState(null);
  const [confirm, setConfirm] = useState(null);
  const load = useCallback(() => api.get("/api/other-payments").then(setD).catch((e) => setNotice({ tone: "err", text: e.message })), [api]);
  useEffect(() => { load(); api.get("/api/clients").then(setClients).catch(() => {}); }, [api, load]);
  const save = async (e) => {
    e.preventDefault();
    try { const r = await api.post("/api/other-payments", { ...f, amount: parseMoney(f.amount) }); setNotice({ tone: "ok", text: r.message }); setF({ client_id: "", payment_type: "", amount: "" }); load(); }
    catch (err) { setNotice({ tone: "err", text: err.message }); }
  };
  const act = async () => {
    const { kind, row } = confirm; setConfirm(null);
    try {
      const r = kind === "verify" ? await api.post(`/api/payments/${row.payment_id}/verify-other`, {}) : await api.request(`/api/payments/${row.payment_id}`, "DELETE");
      setNotice({ tone: "ok", text: r.message }); load();
    } catch (e) { setNotice({ tone: "err", text: e.message }); }
  };
  const type = (id) => d?.types.find((x) => x.id === Number(id));
  return (
    <main className="pg">
      <PageHeader slug="other_payments_form" />
      <Notice notice={notice} onClose={() => setNotice(null)} />
      <section className="panel" style={{ marginBottom: "1.25rem" }}>
        <form className="form" onSubmit={save} style={{ maxWidth: "none" }}>
          <div className="field"><label htmlFor="op-c">Client</label><select id="op-c" required value={f.client_id} onChange={(e) => setF({ ...f, client_id: e.target.value })}>
            <option value="">Select client</option>{clients.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}</select></div>
          <div className="field"><label htmlFor="op-t">Payment type</label><select id="op-t" required value={f.payment_type} onChange={(e) => setF({ ...f, payment_type: e.target.value })}>
            <option value="">Select payment type</option>{(d?.types || []).map((x) => <option key={x.id} value={x.id}>{x.name}</option>)}</select>
            {type(f.payment_type) && <span className="hint">Debits account {type(f.payment_type).debit_account}, credits bank 1010 when verified.</span>}</div>
          <div className="field"><label htmlFor="op-a">Amount (TZS)</label><MoneyInput id="op-a" required value={f.amount} onChange={(v) => setF({ ...f, amount: v })} placeholder="1,000.00" /></div>
          <div className="form-actions"><button type="submit" className="btn primary"><i className="fas fa-folder-plus" /> Register payment</button></div>
        </form>
      </section>
      <section className="panel">
        <div style={{ padding: "1rem 1.25rem", borderBottom: "1px solid var(--line)" }}><h2 style={{ fontSize: "1rem", margin: 0 }}>Unverified payments</h2></div>
        <div className="tbl-wrap"><table className="tbl">
          <thead><tr><th>Date</th><th>Client</th><th>Type</th><th className="num">Amount</th><th>Class</th><th /></tr></thead>
          <tbody>{d?.rows.map((r) => <tr key={r.payment_id}><td>{String(r.payment_date).slice(0, 10)}</td><td style={{ fontWeight: 600, color: "var(--ink)" }}>{r.client_name}</td>
            <td>{r.type_name || "–"}</td><td className="num mono">{n2(r.payment_amount)}</td><td>{r.payment_class}</td>
            <td style={{ whiteSpace: "nowrap" }}><button type="button" className="btn sm primary" onClick={() => setConfirm({ kind: "verify", row: r })}>Verify</button>{" "}
              {user?.role === "admin" && <button type="button" className="btn sm" onClick={() => setConfirm({ kind: "delete", row: r })}>Delete</button>}</td></tr>)}</tbody>
        </table>{d && d.rows.length === 0 && <div className="empty"><i className="fas fa-inbox" />No unverified payments found.</div>}</div>
      </section>
      {confirm && <Modal title={confirm.kind === "verify" ? "Verify this payment?" : "Delete this payment?"} onClose={() => setConfirm(null)}
        actions={<><button type="button" className="btn" onClick={() => setConfirm(null)}>Cancel</button><button type="button" className={`btn ${confirm.kind === "verify" ? "primary" : "danger"}`} onClick={act}>{confirm.kind === "verify" ? "Verify" : "Delete"}</button></>}>
        {confirm.row.type_name} for {confirm.row.client_name}, TZS {n2(confirm.row.payment_amount)}. {confirm.kind === "verify" ? "This posts it to the ledger." : ""} This can't be undone.</Modal>}
    </main>
  );
}
